<template>
  <section
    class="my-share-page"
    v-if="eventStatus === 'error'
     || eventTransactionsStatus === 'error'
     || eventsStatus === 'error'"
  >
    <events-aside :is-mobile="isMobile" :route-id="$route.params.id"/>
    <page-error :showLang="false">
      <template #message>
        {{ $t('CP.errorOccurred') }}
      </template>
    </page-error>
  </section>
  <section
    class="my-share-page"
    v-else-if="(eventsStatus !== 'loading' && events && !events.length)
      || (eventStatus !== 'loading' && !event.id)"
  >
    <events-aside :is-mobile="isMobile" :route-id="$route.params.id"/>
    <empty-event-operations
      v-if="!isMobile || (isMobile && $route.fullPath !== '/events')"
      class="empty-operations"
      :isSearchActive="isSearchActive"
    />
  </section>
  <section
    v-else
    class="my-share-page">
    <events-aside :is-mobile="isMobile" :route-id="$route.params.id"/>
    <operation-panel
      @toggleOptionsPanel="$emit('toggleOptionsPanel')"
      :show-options="showOptions"
      :is-mobile="isMobile" operation="my-share"
    />
    <event-options
      @toggleOptionsPanel="$emit('toggleOptionsPanel')"
      :show-options="showOptions"
      :is-mobile="isMobile"
    />
  </section>
</template>

<script>
import { mapState } from 'vuex';
import EventsAside from '../layouts/EventsAside/EventsAside';
import OperationPanel from '../layouts/OperationPanel/OperationPanel';
import EventOptions from '../layouts/EventOptions/EventOptions';
import EmptyEventOperations from '../components/EmptyEventOperations/EmptyEventOperations';
import PageError from '../layouts/PageError/PageError.vue';

export default {
  name: 'EventsPage',
  components: {
    EmptyEventOperations,
    EventsAside,
    OperationPanel,
    EventOptions,
    PageError,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    showOptions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      events: (state) => state.events.events || [],
      event: (state) => state.events.event,
      eventsStatus: (state) => state.events.eventsStatus,
      eventStatus: (state) => state.events.eventStatus,
      eventTransactionsStatus: (state) => state.events.eventTransactionsStatus,
    }),
    isSearchActive() {
      if (this.eventsStatus !== 'loading' && this.events && this.events.length
        && this.eventStatus === 'cleared') {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
  .my-share-page {
    flex: 1 1 100%;
    min-height: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
  }
  .empty-operations {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .error-message {
    color: var(--error-red);
    height: 100%;
    background: white;
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
